












































import { Component, Vue } from "vue-property-decorator";
import { API } from "@/shared/api";
import axios from "axios";
import { ssmTokenService } from "@/shared/services/token-service";
import DxButton from "devextreme-vue/button";

@Component({
  components: {
    DxButton,
  },
})
export default class kml_import_file extends Vue {
  public archivo: File | null = null;

  onFileChange(event: Event) {
    const target = event.target as HTMLInputElement;
    if (!target.files || target.files.length === 0) {
      console.error("No se ha seleccionado ningún archivo.");
      return;
    }
    const file = target.files[0];
    const extension = file.name.split(".").pop()!.toLowerCase();
    if (extension === "kml") {
      this.archivo = file;
    } else {
      alert("Por favor, selecciona un archivo KML válido.");
    }
  }

  enviarArchivo() {
    if (!this.archivo) {
      alert("No has seleccionado un archivo.");
      return;
    }

    const formData = new FormData();
    formData.append("file", this.archivo);

    axios
      .post(API.kml + "/importar", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + ssmTokenService.getToken(),
        },
      })
      .then((response) => {
        alert("Archivo subido con éxito");
      })
      .catch((error) => {
        console.error("Error al subir el archivo:", error);
      });
  }
}
